export default "__VITE_ASSET__dhsOs$kF__"